import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 300,
      maxHeight: 320,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      padding: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus-visible': {
        outline: `${theme.spacing(0.25)}px solid var(--essential-base)`,
        outlineOffset: -theme.spacing(0.25),
      },
    },
    headerLabel: {
      marginLeft: theme.spacing(0.5),
      fontWeight: 500,
    },
    list: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    groupRow: {
      paddingRight: theme.spacing(1),
    },
    option: {
      '&[data-highlighted="true"]': {
        backgroundColor: theme.palette.action.selected,
      },
    },
    groupChevron: {
      color: theme.palette.text.secondary,
      flexShrink: 0,
      marginLeft: 'auto',
    },
    selectedCount: {
      marginRight: theme.spacing(0.25),
    },
    centered: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
  }),
);
